import { Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subject } from "rxjs";
import { ConfirmationModalComponent } from "../pages/common/confirmation-modal/confirmation-modal.component";

@Injectable({
    providedIn: 'root',
})
    
export class PageLeaveService {
    private pageLeaveSubject = new Subject<void>();

    constructor(
        private router: Router,
        private modalService: NgbModal) {
            this.router.events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    // this.openConfirmationModal();
                }
            });
        }

    // getPageLeaveEvent(): Observable<void> {
    //     console.log('event triggered')
    //     return this.pageLeaveSubject.asObservable();
    // }

    // private openConfirmationModal(): void {
    //     const modalRef = this.modalService.open(ConfirmationModalComponent, { size: 'sm', centered: true, backdrop: 'static', keyboard: false });
    //     modalRef.result.then((result: boolean) => {
    //       // Handle modal result
    //       console.log('result true')
    //     }).catch(() => {
    //       // Handle modal dismissal
    //       console.log('result false')
    //     });
    // }

    confirm(): Promise<boolean> {
        const modalRef = this.modalService.open(ConfirmationModalComponent, 
            {ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl','backdrop': 'static', 'keyboard': false  })
        
        return modalRef.result.then((result: any) => {
            return result;
        }).catch((error) => {console.log(error)
            return false;   
        })
    }
}